module.exports = __webpack_public_path__ + "img/total-soul.4a55f6db.png";